// extracted by mini-css-extract-plugin
module.exports = {"media":"media-module--media--2tWpF"};